import styled from "styled-components";

export const LoginFormStyles = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  .form {
    width: 390px;
    /* Viewport-relative so it shrinks on phones even though the centered auth
       column shrink-wraps to content (a plain max-width: 100% wouldn't bite).
       40px accounts for the AuthLayout mobile side padding. */
    max-width: calc(100vw - 40px);
  }

  .forgotPassword {
    display: flex;
    justify-content: flex-end;
    margin-top: -16px;
    margin-bottom: 24px;
  }

  .link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.accent[400]};
    font-weight: normal;
  }

  .signUp {
    font-weight: normal;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 12px;
    text-align: center;
    margin: 18px 0 0 0;
  }

  .termsText {
    font-weight: normal;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 12px;
    text-align: center;
    margin: 24px 0 0 0;
  }
`;
